/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Closing the tab stops the countdown, since it runs in that page's browser memory. Switching to a different tab or minimizing the window is fine — the timer keeps counting and the alarm still fires — but closing the tab ends it.`)
};

const es_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Cerrar la pestaña detiene la cuenta regresiva, ya que se ejecuta en la memoria del navegador de esa página. Cambiar a otra pestaña o minimizar la ventana no es problema — el temporizador sigue contando y la alarma sigue sonando —, pero cerrar la pestaña la termina.`)
};

const de_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Das Schließen des Tabs stoppt den Countdown, da er im Browser-Speicher dieser Seite läuft. Zu einem anderen Tab wechseln oder das Fenster minimieren ist kein Problem — der Timer läuft weiter und der Alarm ertönt trotzdem —, aber das Schließen des Tabs beendet ihn.`)
};

const nl_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het sluiten van het tabblad stopt de aftelling, omdat deze draait in het browsergeheugen van die pagina. Wisselen naar een ander tabblad of het venster minimaliseren is geen probleem — de timer blijft doortellen en het alarm gaat nog steeds af — maar het sluiten van het tabblad beëindigt hem.`)
};

const fr_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Fermer l’onglet arrête le compte à rebours, car il fonctionne dans la mémoire du navigateur propre à cette page. Passer à un autre onglet ou réduire la fenêtre ne pose aucun problème — le minuteur continue de compter et l’alarme se déclenche toujours — mais fermer l’onglet l’interrompt.`)
};

const it_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Chiudere la scheda interrompe il countdown, perché viene eseguito nella memoria del browser di quella pagina. Passare a un'altra scheda o ridurre a icona la finestra va bene — il timer continua a contare e l'allarme suona comunque — ma chiudere la scheda lo interrompe.`)
};

const pt_br2_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Fechar a aba interrompe a contagem regressiva, já que ela roda na memória do navegador daquela página. Trocar de aba ou minimizar a janela não é problema — o temporizador continua contando e o alarme ainda dispara — mas fechar a aba encerra tudo.`)
};

const pt_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Fechar o separador interrompe a contagem decrescente, pois esta é executada na memória do navegador dessa página. Mudar para outro separador ou minimizar a janela não é problema — o temporizador continua a contar e o alarme continua a tocar — mas fechar o separador termina-o.`)
};

const ja_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。カウントダウンはそのページのブラウザメモリ上で動作しているため、タブを閉じると停止します。別のタブに切り替えたりウィンドウを最小化したりしても問題ありません — タイマーはカウントを続け、アラームも鳴ります — ただしタブを閉じると終了します。`)
};

const zh_timer_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。关闭标签页会停止倒计时，因为它是在该页面的浏览器内存中运行的。切换到其他标签页或最小化窗口都没问题 — 计时器会继续计时，闹铃也照常响起 — 但关闭标签页会终止计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq3_a", locale)
	if (locale === "en") return en_timer_hub_faq3_a(inputs)
	if (locale === "es") return es_timer_hub_faq3_a(inputs)
	if (locale === "de") return de_timer_hub_faq3_a(inputs)
	if (locale === "nl") return nl_timer_hub_faq3_a(inputs)
	if (locale === "fr") return fr_timer_hub_faq3_a(inputs)
	if (locale === "it") return it_timer_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq3_a(inputs)
	if (locale === "pt") return pt_timer_hub_faq3_a(inputs)
	if (locale === "ja") return ja_timer_hub_faq3_a(inputs)
	return zh_timer_hub_faq3_a(inputs)
};